import { useQuery } from "@apollo/client/react";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { DataLoader } from "../../../components";
import { ErrorContainer, LoadingContainer, SuccessContainer } from "../../../components/DataLoader";
import { LoadingIcon } from "../../../components/ui/LoadingIcon";
import type { UserDetailsQuery, UserDetailsQueryVariables } from "../../../graphql/types";
import { UserDetailsDocument } from "../../../graphql/types";
import { AppError } from "../../../pages/static/AppError";
import { UserData } from "../components/UserData";

const UserDetailsPage = () => {
  const { id } = useParams();
  const { loading, error, data } = useQuery<UserDetailsQuery, UserDetailsQueryVariables>(UserDetailsDocument, {
    variables: {
      userId: id ?? "",
    },
    fetchPolicy: "cache-and-network",
  });
  return (
    <Stack
      sx={{
        paddingX: "132px",
      }}
    >
      <DataLoader loading={loading} error={error} success={Boolean(data?.userV2)}>
        <ErrorContainer>
          <AppError />
        </ErrorContainer>
        <LoadingContainer>
          <LoadingIcon />
        </LoadingContainer>
        <SuccessContainer>{data?.userV2 ? <UserData user={data.userV2} /> : null}</SuccessContainer>
      </DataLoader>
    </Stack>
  );
};

export { UserDetailsPage };
